import React from "react";
import { RouteGuard } from "../../guards/RouteGuard";
import { FrequencyConflictsList } from "./FrequencyConflictsList";
function FrequencyConflicts() {
    return (React.createElement(RouteGuard, null,
        React.createElement(FrequencyConflictsList, null)));
}
export default FrequencyConflicts;
